import { FC, useMemo } from 'react'
import ClaudeIcon from './../../../../assets/modelRoundedIcons/claude.svg?react'
import DeepseekIcon from './../../../../assets/modelRoundedIcons/deepseek.svg?react'
import FluxIcon from './../../../../assets/modelRoundedIcons/flux.svg?react'
import GeminiIcon from './../../../../assets/modelRoundedIcons/gemini.svg?react'
import MidjourneyIcon from './../../../../assets/modelRoundedIcons/midjourney.svg?react'
import QwenIcon from './../../../../assets/modelRoundedIcons/qwen.svg?react'
import GoogleImagenIcon from './../../../../assets/modelsIcon/googleImagen.svg?react'
import GptIcon from './../../../../assets/modelsIcon/gpt.svg?react'
import GrokIcon from './../../../../assets/modelsIcon/Grok.svg?react'
import HailuoIcon from './../../../../assets/modelsIcon/hailuo.svg?react'
import HeygenIcon from './../../../../assets/modelsIcon/heygen.svg?react'
import IdeogramIcon from './../../../../assets/modelsIcon/ideogram.svg?react'
import KlingIcon from './../../../../assets/modelsIcon/kling.svg?react'
import PerplexityIcon from './../../../../assets/modelsIcon/perplexity.svg?react'
import QubicoTTSIcon from './../../../../assets/modelsIcon/QubicoTTS.svg?react'
import RecraftIcon from './../../../../assets/modelsIcon/recraft.svg?react'
import StableIcon from './../../../../assets/modelsIcon/Stable.svg?react'
import VeoIcon from './../../../../assets/modelsIcon/veo.svg?react'
import WanxIcon from './../../../../assets/modelsIcon/wanx.svg?react'
import YandexIcon from './../../../../assets/modelsIcon/yandex.svg?react'
import SoraIcon from './../../../../assets/modelsIcon/sora.svg?react'
import NanoBananaIcon from './../../../../assets/modelsIcon/nanobanana.svg?react'

interface Props {
    agentKey?: string
}

export const ModelsCarouselIcon: FC<Props> = ({ agentKey }) => {
    const style = { width: '28px', height: '28px', borderRadius: '50%' }

    const modelIcon = useMemo(() => {
        switch (agentKey) {
            case 'GPT4_LATEST':
            case 'OPENAI_O1_MINI':
            case 'GPT4.5':
            case 'OPENAI_O3_MINI':
            case 'OPENAI_O1':
            case 'OPENAI_O1_PRO':
            case 'OPENAI_TTS':
            case 'GPT_4O_MINI_TTS':
            case 'OPENAI_TTS_HD':
            case 'GPT4_LATEST_MINI':
            case 'GPT4.1_MINI':
            case 'GPT4.1':
            case 'GPT4.1_NANO':
            case 'OPENAI_O4_MINI':
            case 'WHISPER':
            case 'DALL_E_3':
            case 'GPT_4O_IMAGE':
            case 'GPT5':
            case 'GPT5_PRO':
            case 'GPT5_CODE':
            case 'GPT5_IMAGE':
            case 'GPT5_1':
            case 'GPT5_1_CHAT':
            case 'GPT5_2':
            case 'GPT5_2_CHAT':
            case 'GPT5_2_PRO':
                return <GptIcon style={style} />

            case 'YANDEX_LATEST':
            case 'YANDEX_TTS':
                return <YandexIcon style={style} />

            case 'MIDJOURNEY':
                return <MidjourneyIcon style={style} />

            case 'SORA_2':
                return <SoraIcon style={style} />

            case 'CLAUDE_3.5_HAIKU':
            case 'CLAUDE_3.7_SONNET_THINKING':
            case 'CLAUDE_4_SONNET':
            case 'CLAUDE_4_OPUS':
            case 'CLAUDE_4_5_SONNET':
            case 'CLAUDE_4_5_OPUS':
                return <ClaudeIcon style={style} />

            case 'GEMINI_FLASH_1.5_8B':
            case 'GEMINI_FLASH_2.0':
            case 'GEMINI2.5_PRO_PREVIEW':
            case 'GEMINI3_PRO':
            case 'GEMINI_FLASH_2.5':
            case 'GOOGLE_FLASH_EDIT_MULTI':
                return <GeminiIcon style={style} />

            case 'GOOGLE_FLASH_EDIT_MULTI_2_5':
            case 'NANO_BANANA_PRO':
                return <NanoBananaIcon style={style} />

            case 'DEEPSEEK_R1':
            case 'DEEPSEEK_R1_QWEN_3_8B':
            case 'DEEPSEEK_V3.2':
                return <DeepseekIcon style={style} />

            case 'QWEN_QwQ_32B':
                return <QwenIcon style={style} />

            case 'QUBICO_FLUX1_SCHNELL':
            case 'FLUX_1_KONTEXT_MAX':
            case 'FLUX_2_PRO':
                return <FluxIcon style={style} />

            case 'HAILUO':
                return <HailuoIcon style={style} />

            case 'KLING_STANDART_16':
                return <KlingIcon style={style} />

            case 'GROK_2':
            case 'GROK_3_BETA':
            case 'GROK_3_MINI_BETA':
            case 'GROK_4':
            case 'GROK_4_1_FAST':
                return <GrokIcon style={style} />

            case 'STABLE_AUDIO':
                return <StableIcon style={style} />

            case 'QUBICO_TTS':
                return <QubicoTTSIcon style={style} />

            case 'PERPLEXITY_SONAR':
            case 'PERPLEXITY_SONAR_DEEP_RESEARCH':
                return <PerplexityIcon style={style} />

            case 'VEO_3':
            case 'VEO_3_FAST':
            case 'VEO_3_1':
            case 'VEO_3_1_FAST':
                return <VeoIcon style={style} />

            case 'VIDEOGRAM_V3_TURBO':
            case 'VIDEOGRAM_V3_BALANCED':
            case 'VIDEOGRAM_V3_QUALITY':
                return <IdeogramIcon style={style} />

            case 'RECRAFT_V3':
                return <RecraftIcon style={style} />

            case 'HEYGEN_AVATAR':
                return <HeygenIcon style={style} />

            case 'WANX':
                return <WanxIcon style={style} />

            case 'GOOGLE_IMAGEN_4_PREVIEW':
                return <GoogleImagenIcon style={style} />
        }
    }, [agentKey])

    return modelIcon
}
